<template>
    <el-dialog title="请绑定Google验证码" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">
        <div v-show="showBind">
            <qrcode :value="qrCodeUrl" :options="{ width: 200 }"></qrcode>
        </div>

        <div v-show="showAlreadyBind">
            <h4> 您已绑定Google验证码，如需解绑请联系管理员！</h4>
        </div>

        <div v-show="showBind">
            <h4>如您已完成绑定，请点击“我已成功绑定”按钮，系统将不会再显示二维码，防止二次绑定。</h4>
            <el-button type="success" @click="hasAlreadyBind">我已成功绑定</el-button>
        </div>

    </el-dialog>
</template>

<script>

    import md5 from 'js-md5';

    export default {
        name: "BindAuthCode",
        props: {
            show: Boolean,
            formData: Object,
            action: String
        },
        data() {
            return {
                dialogShow: this.show,
                qrCodeUrl: "",
                showBind: false,
                showAlreadyBind: false
            }
        },
        methods: {
            openDialog() {
                this.getAuthCode();
            },
            closeDialog() {
                this.dialogShow = false;
                this.$emit('update:show', false);
            },

            getAuthCode() {
                this.axios.post("/merchant/getAuthCode", {}).then(res => {
                    if (res.code === 200) {

                        // {"code":200,"msg":"请求成功","data":{"bind":false,"qrCode":"otpauth://totp/starpay%3A%E6%B5%8B%E8%AF%95%E5%95%86%E6%88%B7?secret=POGFHI64A2RNUBMI&issuer=starpay"}}


                        var data = res.data;
                        if (data) {
                            if (!data.bind) {
                                this.showBind = true;
                                this.qrCodeUrl = data.qrCode;
                            }else{
                                this.showBind = false;
                                this.showAlreadyBind = true;
                            }
                        }

                    } else {

                        this.$notify.error({
                            title: '请求二维码失败',
                            message: res.msg,
                        });
                    }
                })
            },
            hasAlreadyBind() {
                this.axios.post("/merchant/hasAlreadyBind", {}).then(res => {
                    if (res.code === 200) {

                        this.showBind = false;
                        this.showAlreadyBind = true;

                    } else {
                        this.$notify.error({
                            title: '请求失败，请稍后重试',
                            message: res.msg,
                        });
                    }
                })
            }
        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            }
        },
    }
</script>

<style scoped>

</style>